import styled from 'styled-components';
import Vimeo from '@vimeo/player';
import { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Modal from 'react-modal';

import { __ } from '../locales';
import LinkButton from '../common/LinkButton';
import BodyText from '../common/BodyText';
import { trackEvent } from '../helpers/common';
import events from '../app/events';
import { iframeCall } from '../helpers/iframeHelper';
import CustomButton from '../common/CustomButton';

const Body = styled.p`
  padding: 10px 0;
`;

const VideoContainer = styled.div`
  margin-bottom: 20px;
  min-height: 180px;
  overflow:hidden;
`;

const Title = styled.h2`
  margin-bottom: 10px;
`;

const customModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '75%',
    paddingBottom: 10,
    borderRadius: 8,
    border: 'none'
  }
};

const SignupModal = ({
  isVisible,
  onClose
}) => {
  const createAccount = () => {
    iframeCall('dzSignup');
  };

  const cancel = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isVisible}
      onRequestClose={onClose}
      style={customModalStyles}
      overlayClassName="signup-modal-overlay"
    >
      <Title>
        {__('app.sign_in_required')}
      </Title>
      <div style={{ marginBottom: 15 }}>
        <Body>
          {__('app.in_order_to_proceed_to_quiz')}
        </Body>
      </div>
      <CustomButton
        style={{ margin: '5px 0' }}
        className="btn royal filled"
        onClick={createAccount}
      >
        {__('app.create_account')}
      </CustomButton>
      <LinkButton onClick={cancel}>
        {__('app.cancel')}
      </LinkButton>
    </Modal>
  );
};

const Video = ({
  data,
  id,
  swipeIndex,
  setSwipeIndex,
  accountId,
  lessonData,
  onDone,
  startVideoRequest,
  endVideoRequest,
  isLearningModuleVideo = false,
  hasQuiz = true
}) => {
  const { state } = useLocation();
  const lmIndex = state?.lmIndex;
  const { video_link, message } = data;
  const { push, replace } = useHistory();
  const [showNextBtn, setShowNextBtn] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const player = useRef(undefined);
  let isPlayed = false;
  const isLastItem = swipeIndex === lessonData.length - 1;

  const proceed = () => {
    onDone(id);
    if (!isLastItem) {
      if (isLearningModuleVideo) {
        trackEvent('DZ_RF_NEXT_CTA_TAP');
      } else {
        trackEvent(events.DZ_RF_NEXT_CTA_TAP);
      }
      return setSwipeIndex(swipeIndex + 1);
    }
    if (!accountId) {
      setModalVisible(true);
      return null;
    }

    if (isLearningModuleVideo) {
      trackEvent('DZ_LM_GET_CERTIFIED_BTN_TAP');
    } else {
      trackEvent(events.DZ_RF_GET_CERTIFIED_BTN_TAP);
    }
    return push(`/quiz/${isLearningModuleVideo ? 'lm' : 'rf'}/0`,
      { lmIndex, isLearningModule: isLearningModuleVideo });
  };

  const renderNextCTA = (cn) => {
    if (!isLastItem) {
      return (
        <CustomButton
          style={{ margin: '5px 0' }}
          className={`btn outline ${cn}`}
          onClick={proceed}
        >
          {__('app.next')}
          &nbsp;:&nbsp;
          {lessonData[swipeIndex + 1].title}
        </CustomButton>
      );
    }
    return (
      <CustomButton
        style={{ margin: '5px 0' }}
        className={`btn outline ${cn}`}
        onClick={proceed}
      >
        {isLastItem && !hasQuiz ? __('app.return') : __('app.get_certified')}
      </CustomButton>
    );
  };

  useEffect(() => {
    setShowNextBtn(false);
    const options = {
      id: video_link,
      width: document.getElementById('root').clientWidth - 67,
      texttrack: window.lang
    };

    player.current = new Vimeo(`vimeo-player${id}`, options);

    player.current.on('play', () => {
      if (!isPlayed) {
        isPlayed = true;
        startVideoRequest();
      }
    });

    player.current.on('ended', () => {
      endVideoRequest();
      setShowNextBtn(true);
    });

    return () => {
      player.current.destroy();
    };
  }, [id, swipeIndex]);

  return (
    <div>
      <SignupModal
        isVisible={modalVisible}
        onClose={() => {
          replace('/landing');
          setModalVisible(false);
        }}
      />
      <VideoContainer>
        <div id={`vimeo-player${id}`} style={{ minHeight: 120 }} />
      </VideoContainer>
      {
        showNextBtn && renderNextCTA('cta')
      }
      <BodyText>
        <Body dangerouslySetInnerHTML={{ __html: message }} />
      </BodyText>
      {
        !showNextBtn && renderNextCTA('royal')
      }
    </div>
  );
};

export default Video;
